import { useTranslation } from 'react-i18next';

const RenewalEmptyNotes = () => {
  const { t } = useTranslation();
  return (
    <div className="px-4 py-45 text-center">
      <h3 className="text-secondary-foreground font-semibold mb-2">
        {t('renewal.notesTab.title')}
      </h3>
      <p className="text-sm text-foreground mb-5">
        {t('renewal.notesTab.description')}
      </p>
      <p className="text-xs text-muted-foreground">
        ⚠&nbsp;&nbsp;{t('renewal.notesTab.syncWarning')}
      </p>
    </div>
  );
};

export default RenewalEmptyNotes;
